import { useMutation } from '@tanstack/react-query';
import { CustomerFiles } from '@prisma/client';
import { uploadCustomerFile } from '../../services/customers';
import useUser from '../global/useUser';

interface Options {
  onSuccess?: (data: CustomerFiles) => void;
  onError?: (error: Error) => void;
  refetch?: () => unknown | Promise<unknown>;
}

function useUploadCustomerFile({ onSuccess, onError, refetch }: Options = {}) {
  const { user } = useUser();
  const businessId = user?.business?.id;

  return useMutation({
    mutationFn: async ({
      customerId,
      file,
    }: {
      customerId: string;
      file: File;
    }) => {
      if (!businessId) throw new Error('Business ID is required');
      const result = await uploadCustomerFile({
        file,
        customerId,
        businessId,
      });

      await refetch?.();

      return result;
    },
    onSuccess,
    onError,
  });
}

export default useUploadCustomerFile;
